import { Logo } from '@/components/Logo';
import { useAuth } from '@/features/auth/useAuth';
import { USER_ROLE_LABELS } from '@coreltb/shared/constants';
import { Link } from 'react-router-dom';
import { NavList } from './NavList';
import { initialsOf } from './UserMenu';

/** Sidebar desktop (>= lg). Na mniejszych ekranach: dolny pasek + szuflada. */
export function Sidebar() {
  const { user } = useAuth();

  return (
    <aside
      className="hidden h-full w-60 shrink-0 flex-col border-r border-border bg-sidebar-bg lg:flex"
      aria-label="Panel nawigacji"
    >
      <Link to="/crm" className="flex h-16 shrink-0 items-center px-5" aria-label="CoreLTB — CRM">
        <Logo variant="full" />
      </Link>

      <div className="flex-1 overflow-y-auto px-3 pb-4 pt-2">
        <NavList />
      </div>

      {user && (
        <div className="border-t border-border p-3">
          <div className="flex items-center gap-3 rounded-lg px-2 py-1.5">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-subtle text-xs font-semibold text-accent ring-1 ring-accent/30">
              {initialsOf(user.name)}
            </div>
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm font-medium text-fg">{user.name}</div>
              <div className="truncate text-xs text-fg-muted">
                {USER_ROLE_LABELS[user.role] ?? user.role}
              </div>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}
